<template>
<div>
  <vue-headful
    title="Children's Books, Annuals, and Comics at D&amp;M Books"
    description="D&amp;M Books specialise in buying and selling old and rare children's books, annuals and comics."
    keywords="books, Biggles books,  Billy Bunter Books, Beano Annuals,  Dandy Annuals,  Rupert Annuals,  Chalet School,  D &amp; M Books,  children's books, Howard Baker,  PBFA, children's annuals,  Biggles, Enid Blyton,Giles, Giles Cartoons, storypapers, D. C. Thomson, Elsie Oxenham, Famous Five, Frank Richards, Captain W.E. Johns, school stories, happy hours,Richmal Crompton, children's annuals, Eagle, Rupert Bear,Fairlie-Bruce, Elinor M. Brent-Dyer, Brent-Dyer, John Leng, PBFA member, The Broons, Oor Wullie, Abbey School Books, Chalet School Books, Broons Annuals,Dandy Monster Comic, Malcolm Saville, Lone Pine, Secret Seven, comic books"
  />
  <top-navigation></top-navigation>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-sm-9 padding-right product-information">
            <h2>Online Shop</h2>
            <p>Please visit our eBay shop to see our current selection for sale, if you are interested in making a purchase.</p>
            <p>&nbsp;</p>
            <p><a target="_new" :href="eBayUrl" class="btn btn-default">Visit our eBay Shop</a></p>
        </div>
        <left-sidebar :showBasket=true :showProductCategoryNavigation=true></left-sidebar>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import LeftSidebar from '../../components/common/LeftSidebar';
import TopNavigation from '../../components/common/TopNavigation';
import { EBAY_SHOP_URL } from '../../config';

export default {
  name: 'home',
  data() {
    return {
      eBayUrl: EBAY_SHOP_URL,
    };
  },
  components: {
    'top-navigation': TopNavigation,
    'left-sidebar': LeftSidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/selling/Index.vue